export enum TermType {
	TYPE_FORM_OF_CARE_SUKL = 'sukl_forma_pece',
	TYPE_FIELD_OF_CARE_SUKL = 'sukl_obor_pece',
	INSURANCE_COMPANIES = 'insurance_companies',
	VZP_SUPPLEMENTARY_INSURANCE_TYPE = 'vzp_supplementary_insurance_type',
	SSZ_CODE = 'ssz_code',
	VZP_DPECE = 'vzp_dpece',
	VZP_INVOICE_TIME_PERIOD = 'vzp_invoice_time_period',
	VZP_INVOICE_FEEDBACK_TYPE = 'vzp_invoice_feedback_type',
	VZP_INVOICE_FEEDBACK_MESSAGE_TYPE = 'vzp_invoice_feedback_message_type',
	VZP_INVOICE_FEEDBACK_KEEP_SETTINGS = 'vzp_invoice_feedback_keep_settings',
}
